/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneMarkup from 'sites/allas/components/standalone/Markup';

export const DynamicStandaloneMarkup = StandaloneMarkup;
export type DynamicStandaloneMarkupProps = PropsFromComponent<typeof StandaloneMarkup>;

export const DynamicStandaloneMarkupWith = (extras: DynamicStandaloneExtras): typeof StandaloneMarkup => {
    return function DynamicStandaloneMarkup(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'Markup');
        return <StandaloneMarkup {...mergeProps({ options: { theme } }, props)} />;
    }
}